import {
  ALERT_SUCCESS,
  ALERT_ERROR,
  ALERT_CLEAR,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  FINAL_REGISTER_REQUEST,
  FINAL_REGISTER_SUCCESS,
  FINAL_REGISTER_FAILURE,
  SHOW_PARENTAL_SCREEN,
  SHOW_PARENTAL_SUCCESS,
  SHOW_PARENTAL_RESEND_EMAIL,
  SHOW_MOBILE_VERIFIED,
  RESEND_OTP,
  SET_DEFAULT,
  SHOW_PARENTAL_RESEND_REQUEST,
  TOST_MESSAGE,
  SELF_EMAIL_VERIFICATION,
  REQUEST_SELF_EMAIL_VERIFICATION,
  FINAL_REGISTER_COMPLETION,
} from "./actionTypes";
import { Auth, API, graphqlOperation, Hub } from "aws-amplify";
import * as queries from "../../graphql/queries";
import { updateUserProfileDetails } from "../../graphql/mutations";
import { alertActions } from "./alertActions";
import { loaderActions } from "./loaderActions";
import Storage from "@aws-amplify/storage";
import MaleAvatar from "../../assets/MaleAvatar.png";
import FemaleAvatar from "../../assets/FemaleAvatar.png";
import {
  addEventLog,
  getUseraccess,
  sendparentalconsentEmail,
  sendSmsMobile,
  sendWelcomeEmail,
  sendEmailOtp,
  insertUserInfo,
  sendRequestAfterRegd,
  getUserInfo,
  sendSelfverificationemail,
  smartTechEventLog,
  getUserAuthStatus,
} from "./../auth/util/util";
import moment from "moment";
import {
  createUserMaster,
  createUserProfileDetails,
  updateUserMaster,
} from "../../graphql/mutations";
import fetchItemsNextToken from "../../graphql/fetchItemsNextToken";
import bcrypt from "bcryptjs";
import { Buffer } from "buffer";
import {
  sendemailnsms,
  otpMobileSendDev,
  sendparentalconsent,
  otpvarify,
  getparentalconsent,
  env,
  appLink,
  smarttech,
  userNameA,
  userPassA,
} from "./../auth/util/CustomConstants";
import Link from "@mui/material/Link";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";
import axios from "axios";
import { getSignedUrl } from "./../auth/util/util";

export const userActions = {
  login,
  userLogin,
  logout,
  register,
  sendOTP,
  sendEmailOTP,
  finalRegister,
  parentalRegister,
  verifyOtp,
  resendParentEmail,
  verificationcheck,
  resertRegister,
  socialRegistration,
  setTostMessage,
  SelfEmailVerification,
  SelfEmailVerificationWithoutOtp,
  registercompletion,
  // getAll,
  // delete: _delete
};

function login(username, password, from) {
  return async (dispatch) => {
    dispatch(request({ username }));

    Auth.configure({
      authenticationFlowType: "USER_PASSWORD_AUTH",
    });

    Auth.signIn(username, password)
      .then(async (res) => {
        console.log("res", res);

        dispatch(userActions.userLogin(res, username));
      })
      .catch(async (error) => {
        dispatch(failure(error.toString()));

        console.log("errorres", error);
        let errormessage = error.message.toString();

        if (errormessage.toLowerCase() == "incorrect username or password.") {
          dispatch(
            alertActions.error(
              "Password does not match. Please do forgot password / recheck and try"
            )
          );
        } else if (errormessage.toLowerCase() == "user does not exist.") {
          var regslink = process.env.PUBLIC_URL + "/register";
          let userFound = false;

          // const userData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{filter: {email: {eq: username}},limit:10000}})
          let userData = await fetchSearchItemsNextToken({
            query: queries.searchUserMasters,
            variables: { filter: { email: { eq: username } }, limit: 500 },
          });
          const items = userData;
          let newData = items.filter((item) => item._deleted !== true);
          console.log("newData", newData);
          if (newData.length > 0) {
            // const userDetailsData=await fetchItemsNextToken({query:queries.listUserProfileDetails,variables:{filter: {userMasterUserProfileDetailsId: {eq: newData[0].id}},limit:500}})
            let userDetailsData = await fetchSearchItemsNextToken({
              query: queries.searchUserProfileDetails,
              variables: {
                filter: {
                  userMasterUserProfileDetailsId: { eq: newData[0].id },
                },
                limit: 500,
              },
            });
            console.log("userDetailsData==>", userDetailsData);

            const itemDetails = userDetailsData;
            let newDetailData = itemDetails.filter(
              (item) => item._deleted !== true
            );
            var isSelfEmailVerified =
              newDetailData[0].isSelfEmailVerified == null ||
              newDetailData[0].isSelfEmailVerified == false
                ? 0
                : 1;
            if (isSelfEmailVerified == 0) {
              const encodenewuserID = Buffer.from(newData[0].id).toString(
                "base64"
              );
              regslink =
                process.env.PUBLIC_URL +
                "/registration-completion/" +
                encodenewuserID;
            }

            if (newData[0].password !== "") {
              userFound = true;
            }
          }
          if (userFound === false) {
            dispatch(
              alertActions.error(
                `Looks like your email is not registered with MySphere yet. <a className="App-link" href="${regslink}" rel="noopener noreferrer">Sign Up</a> here.`
              )
            );
          } else {
            dispatch(
              alertActions.error(
                `Password does not match. Please do forgot password / recheck and try.`
              )
            );
          }
        } else {
          dispatch(alertActions.error(error.message.toString()));
        }
      });
  };

  function request(user) {
    return { type: LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: LOGIN_FAILURE, error };
  }
}

function userLogin(res, email) {
  return async (dispatch) => {
    dispatch(loaderActions.start());

    //const userData = await API.graphql(graphqlOperation(queries.listUserMasters,{filter: {email: {eq: email}},limit:10000}));
    let userData = await fetchSearchItemsNextToken({
      query: queries.searchUserMasters,
      variables: { filter: { email: { eq: email } }, limit: 500 },
    });
    // const userData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{filter: {email: {eq: email}},limit:10000}})
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);
    console.log("newData", newData);

    /* USER ACCESS ROLE */
    // const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles,{filter: {isMobileVerified: {eq: 0},isParentVerified: {eq: 0},isSelfEmailVerified: {eq: 0},isDisabled: {eq: 0},isMinor: {eq: 1}},limit:10000}));
    // const userAccessData = await API.graphql(graphqlOperation(queries.listUserAccessRoles,{filter: {isDisabled: {eq: 1}},limit:10000}));
    // console.log('userAccessData==>',userAccessData);
    // const roleitems=userAccessData.data.listUserAccessRoles.items;
    // console.log('roleitems',roleitems);
    // let rolenewData=items.filter(item => item.isDisabled == true);
    // console.log('rolenewData',rolenewData);

    if (newData.length > 0) {
      dispatch(success(email, newData[0]));
      // if(newData[0].status===1)
      // {
      // const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:100000000}));
      // let userDetailsData=await fetchItemsNextToken({query:queries.listUserProfileDetails,variables:{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:500}});
      let userDetailsData = await fetchSearchItemsNextToken({
        query: queries.searchUserProfileDetails,
        variables: {
          filter: { userProfileDetailsUserMasterId: { eq: newData[0].id } },
          limit: 500,
        },
      });
      console.log("userDetailsData==>", userDetailsData);

      const itemDetails = userDetailsData;
      let newDetailData = itemDetails.filter((item) => item._deleted !== true);
      console.log("newDetailData[0]===>", newDetailData[0]);
      var isSelfEmailVerified =
        newDetailData[0].isSelfEmailVerified == null ||
        newDetailData[0].isSelfEmailVerified == false
          ? 0
          : 1;
      var isDisabled = newData[0].disabled == 1 ? 1 : 0;
      console.log("status =>", newData[0].status);
      console.log("isSelfEmailVerified =>", isSelfEmailVerified);
      console.log("isDisabled =>", isDisabled);
      const userrolenewData = getUseraccess(newData[0].id);
      console.log("rolenewData==>", userrolenewData);
      userrolenewData.then(async (rolenewData) => {
        console.log("result =>", rolenewData);
        console.log("canLogin =>", rolenewData.canLogin);

        if (rolenewData != undefined) {
          var allowlogin = true;
          if (rolenewData.canLogin == 0) {
            allowlogin = false;
          } else if (isDisabled == 1) {
            allowlogin = false;
          }
          if (allowlogin) {
            localStorage.setItem("useAccessRole", JSON.stringify(rolenewData));
            //dispatch(success(email,newData[0],newDetailData[0]));
            addEventLog(
              newDetailData[0].id,
              newDetailData[0].id,
              "29f65e9a-e958-4fb0-a191-8822e590c835",
              "",
              ""
            );
            localStorage.setItem("email", newData[0].email);
            localStorage.setItem("firstName", newDetailData[0].first_name);
            localStorage.setItem("lastName", newDetailData[0].last_name);
            localStorage.setItem("userID", newData[0].id);
            localStorage.setItem("userDetailsID", newDetailData[0].id);
            let newUserID = await getUserInfo(newDetailData[0].id);
            localStorage.setItem("newUserID", newUserID);
            localStorage.setItem("gender", newDetailData[0].gender);
            localStorage.setItem("isParent", newDetailData[0].isParent);
            let after7Days = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
            localStorage.setItem("loginExpireTime", after7Days);

            let myfeedTour = newData[0].myfeedTour ? newData[0].myfeedTour : 0;
            let profileTour = newData[0].profileTour
              ? newData[0].profileTour
              : 0;
            let cvTour = newData[0].cvTour ? newData[0].cvTour : 0;
            let projectTour = newData[0].projectTour
              ? newData[0].projectTour
              : 0;

            localStorage.setItem("myfeedTour", myfeedTour);
            localStorage.setItem("profileTour", profileTour);
            localStorage.setItem("cvTour", cvTour);
            localStorage.setItem("projectTour", projectTour);
            localStorage.setItem("isAdmin", newDetailData[0].isAdmin);
            if (newDetailData[0].isGroupSchoolAdmin === 1) {
              localStorage.setItem(
                "isGroupSchoolAdmin",
                newDetailData[0].isGroupSchoolAdmin
              );
            }
            if (newDetailData[0].isSchoolAdmin === 1) {
              localStorage.setItem(
                "isSchoolAdmin",
                newDetailData[0].isSchoolAdmin
              );
            }

            const isTeacher = await fetchSearchItemsNextToken({ query: queries.searchCohorts, variables : {
              filter: {
                teacher_email : { eq: email }
              }
            } })

            if(isTeacher && isTeacher.length > 0){
              localStorage.setItem("isTeacher", 1)
            }else{
              localStorage.setItem("isTeacher", 0)
            }

            // if(newDetailData[0].isAdmin===1)
            // {
            //   localStorage.setItem('isAdmin', newDetailData[0].isAdmin);
            //   if(res.token!='')
            //   {
            //     Auth.signIn(userNameA, userPassA);
            //   }

            // }

            //if(newData[0].isParent==true && newData[0].status==2)
            if (newData[0].status == 2) {
              localStorage.setItem("loginFirstTime", true);
            }
            // if(!newDetailData[0].loginAt)
            //   {
            //     localStorage.setItem("loginFirstTime", true);
            //   }

            let dataForCookie = {
              firstName: newDetailData[0].first_name,
              lastName: newDetailData[0].last_name,
              profileLink: appLink + "profile/" + newDetailData[0].username,
              //gender:newDetailData[0].gender
            };
            if (newDetailData[0].profile_image != null) {
              let imageURL = "";
              let result = await Storage.list(
                "profileThumb/" + newDetailData[0].profile_image
              );
              console.log("string", result);
              if (result.length > 0) {
                imageURL = "profileThumb/" + newDetailData[0].profile_image;
              } else {
                imageURL = newDetailData[0].profile_image;
              }
              await getSignedUrl(imageURL, { level: "public", expires: 604800 })
                .then((link) => {
                  dataForCookie.profilePic = link;
                  localStorage.setItem("uploaded_image", true);
                  localStorage.setItem("profile_image", imageURL);
                })
                .catch((err) => console.log(err));
            } else {
              const avtarnew =
                newDetailData[0].gender == "male" ? MaleAvatar : FemaleAvatar;
              const avtarcookie =
                newDetailData[0].gender == "male"
                  ? appLink +
                    "wp-content/themes/generatepress/assets/imgs/MaleAvatar.png"
                  : appLink +
                    "wp-content/themes/generatepress/assets/imgs/FemaleAvatar.png";
              dataForCookie.profilePic = avtarcookie;
              localStorage.setItem("profile_image", avtarnew);
              localStorage.setItem("uploaded_image", false);
            }

            if (res.attributes) {
              localStorage.setItem(
                "userDetails",
                JSON.stringify(res.attributes)
              );
            } else {
              let prof = {
                sub: newData[0].id,
                birthdate: newDetailData[0].dob,
                email_verified: true,
                gender: newDetailData[0].gender,
                name: `${newDetailData[0].first_name} ${newDetailData[0].last_name}`,
                phone_number_verified: false,
                phone_number: newDetailData[0].mobile_no,
                email: newDetailData[0].email,
              };
              localStorage.setItem("userDetails", JSON.stringify(prof));
            }
            localStorage.setItem("username", newDetailData[0].username);

            const userUpdateData = {
              id: newDetailData[0].id,
              loginAt: new Date(Date.now()).toISOString(),
            };
            let userUpdate = await API.graphql(
              graphqlOperation(updateUserProfileDetails, {
                input: userUpdateData,
              })
            );
            console.log("userUpdate::", userUpdate);

            dispatch(
              success(
                email,
                newData[0],
                userUpdate.data.updateUserProfileDetails,
                dataForCookie
              )
            );
            smartTechEventLog(email, "User Login");
          } else {
            smartTechEventLog(email, "User Login Failed");

            if (isDisabled == 1) {
              dispatch(
                failure(
                  "We're currently experiencing technical difficulties with our login system. Please try again later after some time. We apologize for any inconvenience."
                )
              );
              dispatch(
                alertActions.error(
                  "We're currently experiencing technical difficulties with our login system. Please try again later after some time. We apologize for any inconvenience."
                )
              );
            } else {
              // sendSelfverificationemail(newData[0].id);
              // alert('123')
              dispatch(
                failure(
                  " To login, you'll need to activate your account. Please click on the link we have sent to your email"
                )
              );
              dispatch(
                alertActions.error(
                  " To login, you'll need to activate your account. Please click on the link we have sent to your email"
                )
              );
              //dispatch(failure('Please complete your email verification in order to login'));
              //dispatch(alertActions.error('Please complete your email verification in order to login'));
            }
          }
        } else {
          smartTechEventLog(email, "User Login Failed");
          if (isSelfEmailVerified == 0) {
            dispatch(
              failure(
                "Please complete your email verification in order to login"
              )
            );
            dispatch(
              alertActions.error(
                "Please complete your email verification in order to login"
              )
            );
          }
          if (isDisabled == 1) {
            dispatch(
              failure(
                "We're currently experiencing technical difficulties with our login system. Please try again later after some time. We apologize for any inconvenience."
              )
            );
            dispatch(
              alertActions.error(
                "We're currently experiencing technical difficulties with our login system. Please try again later after some time. We apologize for any inconvenience."
              )
            );
          }
        }
      });
      // }
      // else if(newData[0].status===3)
      // {
      //   dispatch(failure('Your signup request was declined by parent/guardian!'));
      //   dispatch(alertActions.error('Your signup request was declined by parent/guardian!'));
      // }
      // else if(newData[0].status===0)
      // {
      //   dispatch(failure('Awaiting parental consent for your account to be activated'));
      //   dispatch(alertActions.error('Awaiting parental consent for your account to be activated'));
      // }
      // else
      // {

      //   dispatch(failure('Something went wrong. Please try again.'));
      //   dispatch(alertActions.error('Something went wrong. Please try again.'));
      // }
    } else {
      dispatch(failure("Invalid Credentials"));
      dispatch(alertActions.error("Invalid Credentials"));
    }
    dispatch(loaderActions.stop());
  };

  function request(user) {
    return { type: LOGIN_REQUEST, user };
  }
  function success(user, userMaster, userDetails, dataForCookie) {
    return {
      type: LOGIN_SUCCESS,
      user,
      userMaster,
      userDetails,
      dataForCookie,
    };
  }
  function failure(error) {
    return { type: LOGIN_FAILURE, error };
  }
}

function logout() {
  localStorage.removeItem("email");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("userID");
  localStorage.removeItem("userDetailsID");
  localStorage.removeItem("userDetails");
  localStorage.removeItem("username");
  localStorage.removeItem("profile_image");
  localStorage.removeItem("isParent");
  localStorage.removeItem("loginFirstTime");
  localStorage.removeItem("isAdmin");
  localStorage.removeItem("newUserID");
  localStorage.removeItem("useAccessRole");
  localStorage.removeItem("gender");
  if (localStorage.getItem("isGroupSchoolAdmin")) {
    localStorage.removeItem("isGroupSchoolAdmin");
  }
  if (localStorage.getItem("isSchoolAdmin")) {
    localStorage.removeItem("isSchoolAdmin");
  }

  return { type: LOGOUT };
}

function register(formData, city, country, state, dob) {
  return (dispatch) => {
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));
    //console.log('formData===>',formData.get('countryCode')); return false;
    let isExist = userExist(formData.get("email"));
    console.log("isExist", isExist);
    console.log("dob==>", dob);
    isExist.then(async (val) => {
      if (val === true) {
        //dispatch(success(formData));
        let socialEmail = localStorage.getItem("socialEmail");

        let mobilewithcountrycode =
          formData.get("countryCode") + "" + formData.get("mobile");
        addEventLog(
          0,
          0,
          "3cdfcab3-945a-47c9-9e01-471ad3bbb989",
          { mobile: mobilewithcountrycode },
          { email: formData.get("email") }
        );

        let query = `mutation CreateTmpUserDetails {
          createTmpUserDetails(input: {city: ${city}, country: ${country},
            dob:"${moment(dob).format("YYYY-MM-DD")}",email:"${formData.get(
          "email"
        )}",first_name:"${formData.get("firstName")},"gender:"${formData.get(
          "gender"
        )}",last_name: "${formData.get(
          "lastName"
        )}", mobile_no: "${formData.get("countryCode")}${formData.get(
          "mobile"
        )}", state: ${state},referralCode: "${formData
          .get("referralcode")
          .trim()
          .toUpperCase()}",status: 0, userType: ${formData.get("usertype")}
            }) {
           
            city
            country
            createdAt
            dob
            email
            first_name
            gender
            id
            job
            last_name
            middle_name
            mobile_no
            parent_email
            parent_mobile
            parent_name
            state
            referralCode
            status
            userType
            username
          }
          }`;
        console.log("query", query);
        let createTmpUserDetailsQuery = await API.graphql({
          query: query,
        });
        dispatch(
          success(
            createTmpUserDetailsQuery.data.createTmpUserDetails,
            createTmpUserDetailsQuery.data.createTmpUserDetails.id
          )
        );
        addEventLog(
          0,
          0,
          "de8e8299-501a-4bd6-b12e-db1db00fb3a7",
          `{city: ${city}, country: ${country},
          dob:"${moment(dob).format("YYYY-MM-DD")}",email:"${formData.get(
            "email"
          )}",first_name:"${formData.get("firstName")},"gender:"${formData.get(
            "gender"
          )}",last_name: "${formData.get(
            "lastName"
          )}", mobile_no: "${formData.get("countryCode")}${formData.get(
            "mobile"
          )}", state: ${state},referralCode: "${formData
            .get("referralcode")
            .trim()
            .toUpperCase()}",status: 0, userType: ${formData.get("usertype")}
          }`,
          ""
        );
      } else {
        dispatch(
          alertActions.error("This email address is already registered")
        );
        dispatch(failure("This email address is already registered"));
      }
    });
    dispatch(loaderActions.stop());
  };

  function request(user) {
    return { type: REGISTER_REQUEST, user };
  }
  function success(user, logid) {
    return { type: REGISTER_SUCCESS, user, logid: logid };
  }
  function failure(error) {
    return { type: REGISTER_FAILURE, error };
  }
  async function userExist(email) {
    console.log("email", email);
    const userMasterData = await fetchItemsNextToken({
      query: queries.listUserMasters,
      variables: { filter: { email: { eq: email } }, limit: 10000 },
    });
    const items = userMasterData;
    let newMasterData = items.filter((item) => item._deleted !== true);
    if (newMasterData.length > 0) {
      return false;
    } else {
      return true;
    }
    //   Auth.configure({
    //     authenticationFlowType: 'USER_PASSWORD_AUTH',
    //   })
    //   return Auth.signIn(email.toLowerCase(), '123').then(res => {
    //       return false;
    //   }).catch(error => {
    //    const code = error.code;
    //    console.log(code);
    //    switch (code) {
    //        case 'UserNotFoundException':
    //            return true;
    //        case 'NotAuthorizedException':
    //            return false;
    //        case 'PasswordResetRequiredException':
    //          return false;
    //        case 'UserNotConfirmedException':
    //            return false;
    //        default:
    //            return false;
    //    }
    //  });
  }
}

function sendEmailOTP(
  email,
  mobile,
  register,
  social_login,
  resent,
  countryCode
) {
  return (dispatch) => {
    dispatch(loaderActions.start());
    dispatch({ type: RESEND_OTP, openTost: false, tostMsg: "" });
    var data = [
      {
        email: email.toLowerCase(),
        mobile_no: mobile,
        register: register,
        social_login: social_login,
        resent: resent,
        country_code: countryCode,
      },
    ];
    const smsMobile = sendEmailOtp(data);
    if (smsMobile) {
      dispatch({
        type: RESEND_OTP,
        openTost: true,
        tostMsg: "Otp Sent Successfully",
      });
      dispatch(loaderActions.stop());
    } else {
      dispatch(loaderActions.stop());
    }
  };
}

function sendOTP(userid, mobile_no, mobileCountrycode) {
  return (dispatch) => {
    dispatch(loaderActions.start());
    dispatch({ type: RESEND_OTP, openTost: false, tostMsg: "" });

    const smsMobile = sendSmsMobile(userid, mobile_no, mobileCountrycode);
    if (smsMobile) {
      dispatch({
        type: RESEND_OTP,
        openTost: true,
        tostMsg: "Otp Sent Successfully",
      });
      dispatch(loaderActions.stop());
    } else {
      dispatch(loaderActions.stop());
    }
  };
}

function finalRegister(formData) {
  return async (dispatch) => {
    console.log("formData==>", formData);
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      email: formData.email.toLowerCase(),
      otp_email: formData.otp_email,
      otp_mobile: formData.otp_mobile,
      mobile_no: formData.mobile_no,
      name: formData.name,
      first_name: formData.first_name,
      last_name: formData.last_name,
      gender: formData.gender,
      birthdate: formData.birthdate,
      usertype: formData.usertype,
      referralcode: formData.referralcode.trim().toUpperCase(),
      country: formData.country,
      state: formData.state,
      city: formData.city,
      userAge: formData.userAge,
      underAge: formData.underAge,
      skipemailverification: false,
      skipMobileVerification: true,
    });
    console.log("requestOptions==>", raw);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    // fetch(otpMobileSendDev, requestOptions)
    //   .then(response => response.json())
    //   .then(async result =>{

    //  console.log(result);
    //  if(result.finalstatus==true)
    //  {

    let query = `mutation UpdateTmpUserDetails {
                updateTmpUserDetails(input: {id: "${formData.logid}", status: 1
                }) {
                 
                  city
                  country
                  createdAt
                  dob
                  email
                  first_name
                  gender
                  id
                  job
                  last_name
                  middle_name
                  mobile_no
                  parent_email
                  parent_mobile
                  parent_name
                  state
                  referralCode
                  status
                  userType
                  username
                }
                }`;

    await API.graphql({
      query: query,
    });

    // if(formData.userAge>formData.underAge)
    // {
    let username = "";
    checkUsername(
      formData.first_name.toLowerCase() + "-" + formData.last_name.toLowerCase()
    ).then((item) => {
      username = item;
      console.log("username==>55", username);
      Auth.signUp({
        username: formData.email.toLowerCase(),
        password: formData.password,
        attributes: {
          email: formData.email.toLowerCase(),
          name: `${formData.first_name} ${formData.last_name}`,
          phone_number: `+${formData.countryCode}${formData.mobile_no}`,
          birthdate: formData.birthdate_new,
          gender: formData.gender,
        },
      })
        .then(async (user) => {
          console.log("IN 5555");
          let password = formData.hashedPassword;
          var needparent = true;
          //var parentstatus=0;
          if (formData.userAge >= formData.underAge) {
            needparent = false;
            // parentstatus=1;
          }
          let testuser = 0;
          if (
            formData.userDetailsData.referralcode == "internalcg" ||
            formData.userDetailsData.referralcode == "internaldg"
          ) {
            testuser = 1;
          }

          const userMasterData = await fetchItemsNextToken({
            query: queries.listUserMasters,
            variables: {
              filter: { email: { eq: formData.email } },
              limit: 10000,
            },
          });
          const items = userMasterData;
          let newMasterData = items.filter((item) => item._deleted !== true);
          console.log("newData", newMasterData);

          var userdata = "";
          var userid = 0;
          var usermasterid = 0;

          if (newMasterData.length > 0) {
            console.log("newMasterData[0].id", newMasterData[0].id);

            const userDetailsData = await fetchItemsNextToken({
              query: queries.listUserProfileDetails,
              variables: {
                filter: {
                  userProfileDetailsUserMasterId: { eq: newMasterData[0].id },
                },
                limit: 500,
              },
            });
            console.log("userDetailsData==>", userDetailsData);
            const itemDetails = userDetailsData;
            let newDetailData = itemDetails.filter(
              (item) => item._deleted !== true
            );

            console.log("datafetch", newDetailData);

            userid = newDetailData[0].id;
            usermasterid = newDetailData[0].userID.id;

            const userMasterDetailsData = {
              id: usermasterid,
              email: formData.email.toLowerCase(),
              password: password,
              isParent: needparent,
              status: 2,
            };

            console.log("updateuserDetailsData===>", userMasterDetailsData);
            let userMasterupdate = await API.graphql(
              graphqlOperation(updateUserMaster, {
                input: userMasterDetailsData,
              })
            );

            const updateuserDetailsData = {
              id: newDetailData[0].id,
              first_name: formData.userDetailsData.first_name,
              last_name: formData.userDetailsData.last_name,
              username: username,
              userProfileDetailsUserMasterId: usermasterid,
              userMasterUserProfileDetailsId: usermasterid,
              dob: formData.userDetailsData.dob,
              gender: formData.userDetailsData.gender,
              profile_avatar: formData.userDetailsData.profile_avatar,
              about_restriction: 1,
              mobile_no: formData.userDetailsData.mobile_no,
              userType: formData.userDetailsData.userType,
              referralCode: formData.userDetailsData.referralCode
                .trim()
                .toUpperCase(),
              country: formData.userDetailsData.country,
              state: formData.userDetailsData.state,
              city: formData.userDetailsData.city,
              isMobileVerified: false,
              isParentVerified: false,
              isSelfEmailVerified: false,
              isparentRequestSent: false,
              mobileCountrycode: formData.countryCode,
              profile_complition: 10,
              cvs: 0,
              projects: 0,
              mobileSmsTriggerCnt: 0,
              mobileSmsTriggerDt: new Date(Date.now()).toISOString(),
              parentRequestSentTriggerCnt: 0,
              parentRequestSentTriggerDt: new Date(Date.now()).toISOString(),
              selfEmailTriggerCnt: 0,
              selfEmailTriggerDt: new Date(Date.now()).toISOString(),
              welcomeEmailSentCnt: 0,
              welcomeEmailSentDt: new Date(Date.now()).toISOString(),
              mobileReminderSmsTriggerCnt: 0,
              mobileReminderSmsTriggerDt: new Date(Date.now()).toISOString(),
              isTestUser: testuser,
            };

            let userAdd = await API.graphql(
              graphqlOperation(updateUserProfileDetails, {
                input: updateuserDetailsData,
              })
            );

            userdata = updateuserDetailsData;
            console.log("UPDATED USER MASTE DATA===>", userdata);
          } else {
            console.log("in ==>");
            const userData = {
              email: formData.email.toLowerCase(),
              password: password,
              isParent: needparent,
              status: 2,
            };
            console.log("userData ==>", userData);
            let userAdd = await API.graphql(
              graphqlOperation(createUserMaster, { input: userData })
            );
            usermasterid = userAdd.data.createUserMaster.id;
            console.log("CREARED USER MASTER DATA===>", userAdd);
            const userDetailsData = {
              first_name: formData.userDetailsData.first_name,
              last_name: formData.userDetailsData.last_name,
              username: username,
              userProfileDetailsUserMasterId: usermasterid,
              userMasterUserProfileDetailsId: usermasterid,
              dob: formData.userDetailsData.dob,
              gender: formData.userDetailsData.gender,
              profile_avatar: formData.userDetailsData.profile_avatar,
              about_restriction: 1,
              mobile_no: formData.userDetailsData.mobile_no,
              userType: formData.userDetailsData.userType,
              referralCode: formData.userDetailsData.referralCode
                .trim()
                .toUpperCase(),
              country: formData.userDetailsData.country,
              state: formData.userDetailsData.state,
              city: formData.userDetailsData.city,
              isMobileVerified: false,
              isParentVerified: false,
              isSelfEmailVerified: false,
              isparentRequestSent: false,
              mobileCountrycode: formData.countryCode,
              profile_complition: 10,
              cvs: 0,
              projects: 0,
              mobileSmsTriggerCnt: 0,
              mobileSmsTriggerDt: new Date(Date.now()).toISOString(),
              parentRequestSentTriggerCnt: 0,
              parentRequestSentTriggerDt: new Date(Date.now()).toISOString(),
              selfEmailTriggerCnt: 0,
              selfEmailTriggerDt: new Date(Date.now()).toISOString(),
              welcomeEmailSentCnt: 0,
              welcomeEmailSentDt: new Date(Date.now()).toISOString(),
              mobileReminderSmsTriggerCnt: 0,
              mobileReminderSmsTriggerDt: new Date(Date.now()).toISOString(),
              registeredDate: new Date(Date.now()).toISOString(),
              isTestUser: testuser,
            };

            console.log("userDetailsData", userDetailsData);
            let userDetailsAdd = await API.graphql(
              graphqlOperation(createUserProfileDetails, {
                input: userDetailsData,
              })
            );
            console.log("CREATED USER PROFILE DATA", userDetailsAdd);
            userid = userDetailsAdd.data.createUserProfileDetails.id;
            userdata = userDetailsAdd.data.createUserProfileDetails;
          }

          // insertUserInfo({id:userid,first_name:formData.userDetailsData.first_name,last_name:formData.userDetailsData.last_name})
          sendSelfverificationemail(usermasterid);
          localStorage.setItem("email", formData.email);
          localStorage.setItem("userID", usermasterid);

          //const welcomeemail= sendWelcomeEmail(userAdd.data.createUserMaster.id);
          //console.log("EMAIL SENT==>",welcomeemail);
          //sendRequestAfterRegd(formData.email,userid);
          addEventLog(
            userid,
            userid,
            "34b7bd4a-36ef-44a8-8236-9fcdb2815cd9",
            "",
            ""
          );
          // addEventLog(userid,userid,'e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3',userDetailsData,'')
          dispatch(
            userActions.login(formData.email.toLowerCase(), formData.password)
          );
          dispatch(success(userdata, false));
          dispatch(loaderActions.stop());
        })
        .catch((err) => {
          dispatch(alertActions.error("Oops. Something went wrong!"));
          dispatch(loaderActions.stop());
        });
    });
  };

  function request(user) {
    return { type: FINAL_REGISTER_REQUEST, user };
  }
  function success(user, parental) {
    return { type: FINAL_REGISTER_SUCCESS, user, isParent: parental };
  }
  function failure(error) {
    return { type: FINAL_REGISTER_FAILURE, error };
  }
  async function checkUsername(username1) {
    let username = username1.replace(/ +/g, "");
    //const userData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {username: {eq: username}},limit:10000}));
    const userData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: { filter: { username: { eq: username } }, limit: 500 },
    });
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);
    if (newData.length > 0) {
      return checkUsername(username + newData.length);
    } else {
      return username;
    }
  }
}

function parentalRegister(formData) {
  return async (dispatch) => {
    dispatch(loaderActions.start());

    dispatch({ type: SHOW_PARENTAL_SCREEN });
    let userDetailsID = localStorage.getItem("userDetailsID");

    let first_name = localStorage.getItem("firstName");
    let userId = localStorage.getItem("userID");
    let userData = await API.graphql(
      graphqlOperation(queries.getUserProfileDetails, { id: userDetailsID })
    );
    let newData = userData.data.getUserProfileDetails;
    console.log("newData===>", newData);
    console.log("formData===>", formData);
    const userDetailsData = {
      id: userDetailsID,
      parent_name: formData.parentName,
      parent_email: formData.parentEmail.toLowerCase(),
      parent_mobile: formData.parentMobile,
      parentmobileCountrycode: formData.parentCountryCode,
      isparentRequestSent: true,
    };
    console.log("userDetailsData===>", userDetailsData);

    let userAdd = await API.graphql(
      graphqlOperation(updateUserProfileDetails, { input: userDetailsData })
    );

    const sendparentalEmail = sendparentalconsentEmail(userId);
    if (sendparentalEmail) {
      dispatch({ type: SHOW_PARENTAL_SUCCESS, openTost: false, tostMsg: "" });
      dispatch(loaderActions.stop());
    } else {
    }
  };
}

function verifyOtp(formData) {
  return async (dispatch) => {
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());

    const apiName = "welcomeemaildev";
    const path = "/otpMobileSendDev";
    const myInit = {
      body: {
        email: formData.email.toLowerCase(),
        otp_email: formData.otp_email,
        otp_mobile: formData.otp_mobile,
        mobile_no: formData.mobile_no,
        skipemailverification: true,
        skipmobileverification: false,
      },
    };

    await API.post(apiName, path, myInit)
      .then(async (result) => {
        if (result.finalstatus == true) {
          let userID = localStorage.getItem("userID");

          const userMasterData = await fetchItemsNextToken({
            query: queries.listUserMasters,
            variables: { filter: { id: { eq: userID } }, limit: 10000 },
          });
          const items = userMasterData;
          let newMasterData = items.filter((item) => item._deleted !== true);
          console.log("newData", newMasterData);

          if (newMasterData[0].isParent == false) {
            const userMasterDetailsData = { id: userID, status: 1 };
            console.log("userDetailsData===>", userMasterDetailsData);

            let userMasterupdate = await API.graphql(
              graphqlOperation(updateUserMaster, {
                input: userMasterDetailsData,
              })
            );
          }

          let userDetailsID = localStorage.getItem("userDetailsID");
          let userData = await API.graphql(
            graphqlOperation(queries.getUserProfileDetails, {
              id: userDetailsID,
            })
          );
          let newData = userData.data.getUserProfileDetails;
          console.log("newData===>", newData);
          console.log("formData===>", formData);
          const userDetailsData = {
            id: userDetailsID,
            mobile_no: formData.mobile_no,
            isMobileVerified: true,
            mobileCountrycode: formData.countryCode,
          };
          console.log("userDetailsData===>", userDetailsData);

          let userAdd = await API.graphql(
            graphqlOperation(updateUserProfileDetails, {
              input: userDetailsData,
            })
          );
          let userAuthStatus = getUserAuthStatus(
            false,
            newData.userID?.isParent,
            newData?.isParentVerified,
            true,
            true
          );
          const str = `{"EMAIL":"${newData.userID.email.toLowerCase()}","AUTH_VALIDATION_STATUS": "${userAuthStatus}"}`;
          let data = encodeURIComponent(str);
          try {
            await API.post(apiName, "/userinterestupdate", {
              body: { data: data },
            });
          } catch (err) {
            console.log("err", err);
          }

          dispatch({ type: SHOW_MOBILE_VERIFIED });
          dispatch(loaderActions.stop());
        } else {
          if (result.mobile_status == false) {
            // dispatch(failure({mobileError:result.mobile_message}));
            dispatch(alertActions.error(result.mobile_message));
            dispatch(loaderActions.stop());
          }
        }
      })
      .catch((error) => {
        console.log(error.response);
        dispatch(alertActions.error(error.response.data.mobile_message));
        dispatch(loaderActions.stop());
      });

    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify({
    //   "email": formData.email.toLowerCase(),
    //   "otp_email": formData.otp_email,
    //   "otp_mobile": formData.otp_mobile,
    //   "mobile_no": formData.mobile_no,
    //   "skipemailverification": true,
    //   "skipmobileverification": false,

    // });
    // console.log("requestOptions==>",raw);
    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: raw,
    //   redirect: 'follow'
    // };
    //  fetch(otpMobileSendDev, requestOptions)
    //  .then(response => response.json())
    //  .then(async result =>{

    //     console.log(result);
    //     if(result.finalstatus==true)
    //     {

    //       let userID= localStorage.getItem('userID');

    //       const userMasterData=await fetchItemsNextToken({query:queries.listUserMasters,variables:{filter: {id: {eq: userID}},limit:10000}})
    //       const items=userMasterData;
    //       let newMasterData=items.filter(item => item._deleted !== true);
    //       console.log('newData',newMasterData);

    //       if(newMasterData[0].isParent==false)
    //       {

    //         const userMasterDetailsData = { 'id':userID,'status':1};
    //         console.log("userDetailsData===>",userMasterDetailsData);

    //         let userMasterupdate=await API.graphql(graphqlOperation(updateUserMaster, { input: userMasterDetailsData }));
    //       }

    //       let userDetailsID= localStorage.getItem('userDetailsID');
    //       let userData=await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userDetailsID }));
    //       let newData=userData.data.getUserProfileDetails;
    //       console.log("newData===>",newData);
    //       console.log("formData===>",formData);
    //       const userDetailsData = { 'id':userDetailsID,'mobile_no':formData.mobile_no,'isMobileVerified':true,'mobileCountrycode':formData.countryCode};
    //       console.log("userDetailsData===>",userDetailsData);

    //       let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));

    //       dispatch({ type: SHOW_MOBILE_VERIFIED })
    //       dispatch(loaderActions.stop());

    //     }
    //     else
    //     {
    //       if(result.mobile_status==false)
    //       {

    //         // dispatch(failure({mobileError:result.mobile_message}));
    //          dispatch(alertActions.error(result.mobile_message));
    //          dispatch(loaderActions.stop());
    //       }
    //     }
    //    })
    //    .catch(error => {
    //      console.log('error', error);
    //      dispatch(loaderActions.stop());
    //   });
  };
  // function success(user,parental) { return { type: FINAL_REGISTER_SUCCESS, user,isParent:parental } }
  //function failure(error) { return { type: FINAL_REGISTER_FAILURE, error } }
}

function resendParentEmail() {
  return async (dispatch) => {
    dispatch({
      type: SHOW_PARENTAL_RESEND_REQUEST,
      openTost: false,
      tostMsg: "",
    });
    let userId = localStorage.getItem("userID");
    const sendparentalEmail = sendparentalconsentEmail(userId);
    if (sendparentalEmail) {
      dispatch({
        type: SHOW_PARENTAL_RESEND_EMAIL,
        openTost: true,
        tostMsg: "Parental Consent Email Sent Succesfully",
      });
    }
  };
}

function verificationcheck(data) {
  return (dispatch) => {
    dispatch({
      type: SET_DEFAULT,
      mobileVerified: data.mobileVerified,
      parentVerified: data.parentVerified,
      isparentRequestSent: data.isparentRequestSent,
    });
  };
}

function resertRegister() {
  return (dispatch) => {
    dispatch({ type: REGISTER_REQUEST });
  };
}

function socialRegistration(formData, sendData) {
  return async (dispatch) => {
    console.log("formData==>", formData);
    console.log("sendData==>", sendData);
    console.log("formData==>", formData.get("firstName"));
    //dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));

    let mobilewithcountrycode =
      formData.get("countryCode") + "" + formData.get("mobile");
    addEventLog(
      0,
      0,
      "3cdfcab3-945a-47c9-9e01-471ad3bbb989",
      { mobile: mobilewithcountrycode },
      { email: formData.get("email") }
    );

    let firstquery = `mutation CreateTmpUserDetails {
          createTmpUserDetails(input: {city: ${sendData.city}, country: ${
      sendData.country
    },
             dob:"${moment(sendData.dob).format(
               "YYYY-MM-DD"
             )}",email:"${formData.get("email")}",first_name:"${formData.get(
      "firstName"
    )},"gender:"${formData.get("gender")}",last_name: "${formData.get(
      "lastName"
    )}", mobile_no: "${formData.get("countryCode")}${formData.get(
      "mobile"
    )}", state: ${sendData.state},referralCode: "${formData
      .get("referralcode")
      .trim()
      .toUpperCase()}",status: 0, userType: ${formData.get("usertype")}
            }) {
            
            city
            country
            createdAt
            dob
            email
            first_name
            gender
            id
            job
            last_name
            middle_name
            mobile_no
            parent_email
            parent_mobile
            parent_name
            state
            referralCode
            status
            userType
            username
          }
          }`;
    console.log("query", firstquery);
    let createTmpUserDetailsQuery = await API.graphql({
      query: firstquery,
    });
    let logid = createTmpUserDetailsQuery.data.createTmpUserDetails.id;
    console.log("logid==>", logid);
    let query = `mutation UpdateTmpUserDetails {
                updateTmpUserDetails(input: {id: "${logid}", status: 1
                }) {
                  
                  city
                  country
                  createdAt
                  dob
                  email
                  first_name
                  gender
                  id
                  job
                  last_name
                  middle_name
                  mobile_no
                  parent_email
                  parent_mobile
                  parent_name
                  state
                  referralCode
                  status
                  userType
                  username
                }
                }`;

    await API.graphql({
      query: query,
    });

    // if(formData.userAge>formData.underAge)
    // {${formData.get('firstName')
    let username = "";
    checkUsername(
      formData.get("firstName").toLowerCase() +
        "-" +
        formData.get("lastName").toLowerCase()
    ).then((item) => {
      username = item;
      console.log("username", username);
      Auth.signUp({
        username: formData.get("email").toLowerCase(),
        password: formData.get("password"),
        attributes: {
          email: formData.get("email").toLowerCase(),
          name: `${formData.get("firstName")} ${formData.get("lastName")}`,
          phone_number: `+${formData.get("countryCode")}${formData.get(
            "mobile"
          )}`,
          birthdate: formData.get("birthdate"),
          gender: formData.get("gender"),
        },
      })
        .then(async (user) => {
          const salt = bcrypt.genSaltSync(10);
          const hashedPassword = bcrypt.hashSync(
            formData.get("password"),
            salt
          );
          let password = hashedPassword;
          var needparent = true;
          //var parentstatus=0;
          if (sendData.userAge >= sendData.underAge) {
            needparent = false;
            // parentstatus=1;
          }
          const userData = {
            email: formData.get("email").toLowerCase(),
            password: password,
            status: 2,
            isParent: needparent,
          };
          let userAdd = await API.graphql(
            graphqlOperation(createUserMaster, { input: userData })
          );
          console.log("userAdd", userAdd);

          const userDetailsData = {
            first_name: formData.get("firstName"),
            last_name: formData.get("lastName"),
            username: username,
            userProfileDetailsUserMasterId: userAdd.data.createUserMaster.id,
            userMasterUserProfileDetailsId: userAdd.data.createUserMaster.id,
            dob: moment(sendData.dob).format("YYYY-MM-DD"),
            gender: formData.get("gender"),
            profile_avatar: formData.get("gender"),
            about_restriction: 1,
            mobile_no: formData.get("mobile"),
            mobileCountrycode: formData.get("countryCode"),
            userType: sendData.usertype,
            referralCode: formData.get("referralCode").trim().toUpperCase(),
            country: sendData.country,
            state: sendData.state,
            city: sendData.city,
            isMobileVerified: false,
            isParentVerified: false,
            isSelfEmailVerified: true,
            isparentRequestSent: false,
            mobileCountrycode: formData.countryCode,
            profile_complition: 10,
            cvs: 0,
            projects: 0,
            mobileSmsTriggerCnt: 0,
            mobileSmsTriggerDt: new Date(Date.now()).toISOString(),
            parentRequestSentTriggerCnt: 0,
            parentRequestSentTriggerDt: new Date(Date.now()).toISOString(),
            selfEmailTriggerCnt: 0,
            selfEmailTriggerDt: new Date(Date.now()).toISOString(),
            welcomeEmailSentCnt: 1,
            welcomeEmailSentDt: new Date(Date.now()).toISOString(),
            mobileReminderSmsTriggerCnt: 0,
            mobileReminderSmsTriggerDt: new Date(Date.now()).toISOString(),
            registeredDate: new Date(Date.now()).toISOString(),
          };

          console.log("userDetailsData", userDetailsData);

          let userDetailsAdd = await API.graphql(
            graphqlOperation(createUserProfileDetails, {
              input: userDetailsData,
            })
          );
          console.log("userDetailsAdd", userDetailsAdd);

          let userid = userDetailsAdd.data.createUserProfileDetails.id;
          // insertUserInfo({id:userid,first_name:userDetailsAdd.data.createUserProfileDetails.first_name,last_name:userDetailsAdd.data.createUserProfileDetails.last_name})
          const welcomeemail = sendWelcomeEmail(
            userAdd.data.createUserMaster.id
          );
          addEventLog(
            userid,
            userid,
            "34b7bd4a-36ef-44a8-8236-9fcdb2815cd9",
            "",
            ""
          );
          dispatch(
            userActions.login(formData.get("email"), formData.get("password"))
          );
          dispatch(
            success(userDetailsAdd.data.createUserProfileDetails, false)
          );
          dispatch(loaderActions.stop());
        })
        .catch((err) => {
          dispatch(alertActions.error("Oops. Something went wrong!"));
          dispatch(loaderActions.stop());
        });
    });
  };

  function request(user) {
    return { type: FINAL_REGISTER_REQUEST, user };
  }
  function success(user, parental) {
    return { type: FINAL_REGISTER_SUCCESS, user, isParent: parental };
  }
  function failure(error) {
    return { type: FINAL_REGISTER_FAILURE, error };
  }
  async function checkUsername(username) {
    //const userData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {username: {eq: username}},limit:10000}));
    const userData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: { filter: { username: { eq: username } }, limit: 500 },
    });
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);
    if (newData.length > 0) {
      return checkUsername(username + newData.length);
    } else {
      return username;
    }
  }
}

function setTostMessage(openTost, tostmessage) {
  return (dispatch) => {
    dispatch({ type: TOST_MESSAGE, openTost: openTost, tostMsg: tostmessage });
  };
}

function SelfEmailVerification(formData) {
  return async (dispatch) => {
    console.log("formData==>", formData);
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));

    const userData = await API.graphql(
      graphqlOperation(queries.listUserMasters, {
        filter: { email: { eq: formData.email } },
        limit: 10000,
      })
    );
    const items = userData.data.listUserMasters.items;
    //console.log("SELF EMAIL items==>",items);
    let newData = items.filter((item) => item._deleted !== true);
    console.log("userDetailsData==>", newData);
    //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:10000}));
    let userDetailsData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: {
        filter: { userMasterUserProfileDetailsId: { eq: newData[0].id } },
        limit: 500,
      },
    });
    console.log("userDetailsData==>", userDetailsData);
    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);

    const apiName = "welcomeemaildev";
    const path = "/otpMobileSendDev";
    const myInit = {
      body: {
        email: formData.email.toLowerCase(),
        otp_email: formData.otp_email,
        otp_mobile: formData.otp_mobile,
        mobile_no: newDetailData[0].mobile_no,
        name: "",
        first_name: newDetailData[0].first_name,
        last_name: newDetailData[0].last_name,
        gender: newDetailData[0].gender,
        birthdate: newDetailData[0].dob,
        usertype: "",
        referralcode: newDetailData[0].referralCode.trim().toUpperCase(),
        country: newDetailData[0].country,
        state: formData.state,
        city: newDetailData[0].city,
        userAge: "",
        underAge: "",
        skipemailverification: false,
        skipMobileVerification: true,
      },
    };

    await API.post(apiName, path, myInit)
      .then(async (result) => {
        if (result.finalstatus == true) {
          console.log("newDetailData hey ==>", newDetailData);
          if (
            newDetailData[0].isSelfEmailVerified === false ||
            newDetailData[0].isSelfEmailVerified == null
          ) {
            let mobileVerified = false;
            if (newDetailData[0].mobileCountrycode !== "91") {
              console.log("check international");
              mobileVerified = true;
            } else {
              console.log("check international no");
            }
            const userDetailsData = {
              id: newDetailData[0].id,
              isSelfEmailVerified: true,
              isMobileVerified: mobileVerified,
            };
            let userAdd = await API.graphql(
              graphqlOperation(updateUserProfileDetails, {
                input: userDetailsData,
              })
            );
            if (userAdd) {
              console.log("check international user");
              const welcomeemail = sendWelcomeEmail(newData[0].id);

              if (welcomeemail) {
                dispatch(success());
              }
            }
            dispatch(loaderActions.stop());
          } else {
            dispatch(
              failure({ emailError: "This email address is already verified" })
            );
            dispatch(loaderActions.stop());
          }
        } else {
          if (result.mobile_status == false) {
            dispatch(failure({ mobileError: result.mobile_message }));
            dispatch(loaderActions.stop());
          }
          if (result.email_status == false) {
            dispatch(failure({ emailError: result.email_message }));
            dispatch(loaderActions.stop());
          }
        }
      })
      .catch((error) => {
        console.log(error.response);
      });

    // var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/json");

    // var raw = JSON.stringify({
    // "email": formData.email.toLowerCase(),
    // "otp_email": formData.otp_email,
    // "otp_mobile": formData.otp_mobile,
    // "mobile_no": newDetailData[0].mobile_no,
    // "name": '',
    // "first_name": newDetailData[0].first_name,
    // "last_name": newDetailData[0].last_name,
    // "gender":newDetailData[0].gender,
    // "birthdate":newDetailData[0].dob,
    // "usertype":"",
    // "referralcode":newDetailData[0].referralCode,
    // "country":newDetailData[0].country,
    // "state":formData.state,
    // "city":newDetailData[0].city,
    // "userAge":'',
    // "underAge":'',
    // "skipemailverification":false,
    // "skipMobileVerification":true,

    // });

    // var requestOptions = {
    // method: 'POST',
    // headers: myHeaders,
    // body: raw,
    // redirect: 'follow'
    // };

    // fetch(otpMobileSendDev, requestOptions)
    // .then(response => response.json())
    // .then(async result =>{
    // console.log(result);
    //     if(result.finalstatus==true)
    //     {
    //         console.log("newDetailData==>",newDetailData);
    //         if(newDetailData[0].isSelfEmailVerified===false || newDetailData[0].isSelfEmailVerified==null)
    //         {
    //         const userDetailsData = { 'id':newDetailData[0].id,'isSelfEmailVerified':true};
    //         let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
    //         if(userAdd)
    //         {
    //         const welcomeemail= sendWelcomeEmail(newData[0].id);

    //         if(welcomeemail)
    //         {

    //         dispatch(success());

    //         }
    //         }
    //         dispatch(loaderActions.stop());
    //         }
    //         else
    //         {
    //         dispatch(failure({emailError:"This email address is already verified"}));
    //         dispatch(loaderActions.stop());
    //         }

    //     }
    //     else
    //     {
    //         if(result.mobile_status==false)
    //         {
    //         dispatch(failure({mobileError:result.mobile_message}));
    //         dispatch(loaderActions.stop());
    //         }
    //         if(result.email_status==false)
    //         {
    //         dispatch(failure({emailError:result.email_message}));
    //         dispatch(loaderActions.stop());
    //         }
    //     }
    // })
    // .catch(error => {console.log('error', error);});
  };

  function request(user) {
    return { type: REQUEST_SELF_EMAIL_VERIFICATION, user };
  }
  function success() {
    return { type: SELF_EMAIL_VERIFICATION };
  }
  function failure(error) {
    return { type: FINAL_REGISTER_FAILURE, error };
  }
}

function SelfEmailVerificationWithoutOtp(formData) {
  return async (dispatch) => {
    console.log("formData==>", formData);
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    //const userData = await API.graphql(graphqlOperation(queries.listUserMasters,{filter: {email: {eq: formData.email}},limit:10000}));
    const userData = await fetchItemsNextToken({
      query: queries.listUserMasters,
      variables: { filter: { email: { eq: formData.email } }, limit: 10000 },
    });
    const items = userData;
    //console.log("SELF EMAIL items==>",items);
    let newData = items.filter((item) => item._deleted !== true);
    console.log("userDetailsData==>", newData);
    const registerBy = newData[0].registerBy == 1 ? 1 : 0;

    //const userDetailsData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {userProfileDetailsUserMasterId: {eq: newData[0].id}},limit:10000}));
    const userDetailsData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: {
        filter: { userMasterUserProfileDetailsId: { eq: newData[0].id } },
        limit: 500,
      },
    });
    console.log("userDetailsData==>", userDetailsData);

    const itemDetails = userDetailsData;
    let newDetailData = itemDetails.filter((item) => item._deleted !== true);

    console.log("newDetailData==>", newDetailData);
    // console.log("isSelfEmailVerified==>",newDetailData[0].isSelfEmailVerified);

    const DetailsData = {
      first_name: newDetailData[0].first_name,
      last_name: newDetailData[0].last_name,
      username: newDetailData[0].username,
      userProfileDetailsUserMasterId:
        newDetailData[0].userProfileDetailsUserMasterId,
      userMasterUserProfileDetailsId:
        newDetailData[0].userProfileDetailsUserMasterId,
      dob: newDetailData[0].dob,
      gender: newDetailData[0].gender,
      profile_avatar: newDetailData[0].profile_image,
      about_restriction: 1,
      mobile_no: newDetailData[0].mobile_no,
      userType: newDetailData[0].userType,
      referralCode: newDetailData[0].referralCode.trim().toUpperCase(),
      isMobileVerified: false,
      isParentVerified: false,
      isSelfEmailVerified: true,
      isparentRequestSent: false,
      mobileCountrycode: newDetailData[0].country,
      profile_complition: 10,
      cvs: 0,
      projects: 0,
      mobileSmsTriggerCnt: 0,
      mobileSmsTriggerDt: new Date(Date.now()).toISOString(),
      parentRequestSentTriggerCnt: 0,
      parentRequestSentTriggerDt: new Date(Date.now()).toISOString(),
      selfEmailTriggerCnt: 0,
      selfEmailTriggerDt: new Date(Date.now()).toISOString(),
      welcomeEmailSentCnt: 0,
      welcomeEmailSentDt: new Date(Date.now()).toISOString(),
      mobileReminderSmsTriggerCnt: 0,
      mobileReminderSmsTriggerDt: new Date(Date.now()).toISOString(),
    };

    if (
      newDetailData[0].isSelfEmailVerified === false ||
      newDetailData[0].isSelfEmailVerified == null
    ) {
      let userAuthStatus = "";
      let mobileVerified = false;
      if (
        newDetailData[0]?.mobileCountrycode &&
        newDetailData[0]?.mobileCountrycode !== "91"
      ) {
        console.log("check international");
        mobileVerified = true;
        userAuthStatus = getUserAuthStatus(
          false,
          newDetailData[0].userID?.isParent,
          false,
          true,
          true
        );
      } else {
        console.log("check international no");
        userAuthStatus = getUserAuthStatus(
          false,
          newDetailData[0].userID?.isParent,
          false,
          false,
          true
        );
      }
      console.log("check status", userAuthStatus);
      const apiName = "welcomeemaildev";
      const path = "/smarttechuser";
      const myInit = {
        body: {
          email: newData[0].email.toLowerCase(),
          otp_email: "",
          otp_mobile: "",
          mobile_no: newDetailData[0].mobile_no,
          name: "",
          first_name: newDetailData[0].first_name,
          last_name: newDetailData[0].last_name,
          gender: newDetailData[0].gender,
          birthdate: newDetailData[0].dob,
          usertype: "",
          referralcode: newDetailData[0].referralCode.trim().toUpperCase(),
          country: newDetailData[0].country,
          state: formData.state,
          city: newDetailData[0].city,
          userAge: "",
          underAge: "",
          skipemailverification: false,
          skipMobileVerification: true,
        },
      };

      await API.post(apiName, path, myInit)
        .then(async (response) => {
          const str = `{"EMAIL":"${newData[0].email.toLowerCase()}","AUTH_VALIDATION_STATUS": "${userAuthStatus}"}`;
          let data = encodeURIComponent(str);
          try {
            await API.post(apiName, "/userinterestupdate", {
              body: { data: data },
            });
          } catch (err) {
            console.log("err", err);
          }

          const userDetailsData = {
            id: newDetailData[0].id,
            isSelfEmailVerified: true,
            isMobileVerified: mobileVerified,
          };
          let userAdd = await API.graphql(
            graphqlOperation(updateUserProfileDetails, {
              input: userDetailsData,
            })
          );
          if (userAdd) {
            sendRequestAfterRegd(newData[0].email, newDetailData[0].id);
            const welcomeemail = sendWelcomeEmail(newData[0].id);
            addEventLog(
              newDetailData[0].id,
              newDetailData[0].id,
              "e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3",
              "",
              ""
            );
            if (welcomeemail) {
              dispatch(success(registerBy));
              //addEventLog(newDetailData[0].id,newDetailData[0].id,'34b7bd4a-36ef-44a8-8236-9fcdb2815cd9','','')
              addEventLog(
                newDetailData[0].id,
                newDetailData[0].id,
                "e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3",
                DetailsData,
                ""
              );
            }
          }
          dispatch(loaderActions.stop());
        })
        .catch((error) => {
          console.log(error.response);
        });

      // var raw = JSON.stringify({
      //   "email": newData[0].email.toLowerCase(),
      //   "otp_email": '',
      //   "otp_mobile": '',
      //   "mobile_no": newDetailData[0].mobile_no,
      //   "name": '',
      //   "first_name": newDetailData[0].first_name,
      //   "last_name": newDetailData[0].last_name,
      //   "gender":newDetailData[0].gender,
      //   "birthdate":newDetailData[0].dob,
      //   "usertype":"",
      //   "referralcode":newDetailData[0].referralCode,
      //   "country":newDetailData[0].country,
      //   "state":formData.state,
      //   "city":newDetailData[0].city,
      //   "userAge":'',
      //   "underAge":'',
      //   "skipemailverification":false,
      //   "skipMobileVerification":true,

      //   });

      //   var requestOptions = {
      //   method: 'POST',
      //   headers: myHeaders,
      //   body: raw,
      //   redirect: 'follow'
      //   };
      //   //fetch(otpvarify, requestOptions)
      //   fetch(smarttech, requestOptions)
      //   .then(response => response.json())
      //   .then(async result =>{
      //   console.log(result);

      //   // alert("1111");
      //   const userDetailsData = { 'id':newDetailData[0].id,'isSelfEmailVerified':true};
      //    let userAdd=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
      //    if(userAdd)
      //    {

      //      sendRequestAfterRegd(newData[0].email,newDetailData[0].id);
      //        const welcomeemail= sendWelcomeEmail(newData[0].id);
      //        addEventLog(newDetailData[0].id,newDetailData[0].id,'e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3','','')
      //        if(welcomeemail)
      //        {

      //        dispatch(success(registerBy));
      //        //addEventLog(newDetailData[0].id,newDetailData[0].id,'34b7bd4a-36ef-44a8-8236-9fcdb2815cd9','','')
      //        addEventLog(newDetailData[0].id,newDetailData[0].id,'e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3',DetailsData,'')

      //        }
      //    }
      //    dispatch(loaderActions.stop());
      //   })
      //   .catch(error => {console.log('error', error);});
    } else {
      dispatch(
        failure({ emailError: "This email address is already verified" })
      );
      dispatch(loaderActions.stop());
    }
  };

  function request(user) {
    return { type: REQUEST_SELF_EMAIL_VERIFICATION, user };
  }
  function success(registerBy) {
    return { type: SELF_EMAIL_VERIFICATION, registerBy: registerBy };
  }
  function failure(error) {
    return { type: FINAL_REGISTER_FAILURE, error };
  }
}

function registercompletion(formData, city, country, state, dob) {
  return (dispatch) => {
    dispatch(loaderActions.start());
    dispatch(alertActions.clear());
    dispatch(request(formData));
    //console.log('formData===>',formData.get('countryCode')); return false;
    let isExist = userExist(formData.email);
    console.log("isExist", isExist);
    //console.log("dob==>",dob);
    isExist.then(async (val) => {
      if (val === true) {
        Auth.signUp({
          username: formData.email.toLowerCase(),
          password: formData.password,
          attributes: {
            email: formData.email.toLowerCase(),
            name: `${formData.first_name} ${formData.last_name}`,
            phone_number: `+${formData.countryCode}${formData.mobile_no}`,
            birthdate: formData.birthdate_new,
            gender: formData.gender,
          },
        })
          .then(async (user) => {
            let username = "";
            checkUsername(
              formData.userDetailsData.first_name.toLowerCase() +
                "-" +
                formData.userDetailsData.last_name.toLowerCase()
            ).then(async (item) => {
              username = item;

              const apiName = "welcomeemaildev";
              const path = "/smarttechuser";
              const myInit = {
                body: {
                  email: formData.email.toLowerCase(),
                  otp_email: "",
                  otp_mobile: "",
                  mobile_no: formData.userDetailsData.mobile_no,
                  name: "",
                  first_name: formData.userDetailsData.first_name,
                  last_name: formData.userDetailsData.last_name,
                  gender: formData.userDetailsData.gender,
                  birthdate: formData.userDetailsData.dob,
                  usertype: "",
                  referralcode: formData.userDetailsData.referralCode
                    .trim()
                    .toUpperCase(),
                  country: "",
                  state: "",
                  city: "",
                  userAge: "",
                  underAge: "",
                  skipemailverification: false,
                  skipMobileVerification: true,
                },
              };

              await API.post(apiName, path, myInit)
                .then(async (response) => {
                  let password = formData.hashedPassword;
                  var needparent = true;
                  //var parentstatus=0;
                  if (formData.userAge >= formData.underAge) {
                    needparent = false;
                    // parentstatus=1;
                  }
                  console.log("in ==>");

                  const userMasterDetailsData = {
                    id: formData.userid,
                    isParent: needparent,
                  };
                  let userMasterupdate = await API.graphql(
                    graphqlOperation(updateUserMaster, {
                      input: userMasterDetailsData,
                    })
                  );

                  console.log("update user master");
                  const userDetailsData = {
                    id: formData.userdetailsid,
                    first_name: formData.userDetailsData.first_name,
                    last_name: formData.userDetailsData.last_name,
                    username: username,
                    dob: formData.userDetailsData.dob,
                    gender: formData.userDetailsData.gender,
                    mobile_no: formData.userDetailsData.mobile_no,
                    referralCode: formData.userDetailsData.referralCode
                      .trim()
                      .toUpperCase(),
                    isMobileVerified: false,
                    isParentVerified: false,
                    isSelfEmailVerified: true,
                    isparentRequestSent: false,
                    mobileCountrycode: formData.countryCode,
                  };

                  let userUpdate = await API.graphql(
                    graphqlOperation(updateUserProfileDetails, {
                      input: userDetailsData,
                    })
                  );
                  console.log("UPDATE PROFILE DETAILS");
                  sendRequestAfterRegd(
                    formData.email.toLowerCase(),
                    formData.userdetailsid,
                    formData
                  );
                  console.log("DONE REGD REQUEST");
                  const welcomeemail = sendWelcomeEmail(formData.userid);
                  console.log("SEND WELCOME EMAIL");
                  if (welcomeemail) {
                    console.log("BEFORE EVENT LOG");
                    addEventLog(
                      formData.userdetailsid,
                      formData.userdetailsid,
                      "e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3",
                      userDetailsData,
                      ""
                    );
                    console.log("AFTER EVENT LOG");
                  }

                  localStorage.setItem("email", formData.email);
                  localStorage.setItem("userID", formData.userid);
                  dispatch(
                    userActions.login(
                      formData.email.toLowerCase(),
                      formData.password
                    )
                  );
                  dispatch(success(userDetailsData, false));
                  console.log("SUCCESS");
                  dispatch(loaderActions.stop());
                })
                .catch((error) => {
                  console.log(error.response);
                });
              // var raw = JSON.stringify({
              //   "email": formData.email.toLowerCase(),
              //   "otp_email": '',
              //   "otp_mobile": '',
              //   "mobile_no": formData.userDetailsData.mobile_no,
              //   "name": '',
              //   "first_name": formData.userDetailsData.first_name,
              //   "last_name": formData.userDetailsData.last_name,
              //   "gender":formData.userDetailsData.gender,
              //   "birthdate":formData.userDetailsData.dob,
              //   "usertype":"",
              //   "referralcode":formData.userDetailsData.referralCode,
              //   "country":'',
              //   "state":'',
              //   "city":'',
              //   "userAge":'',
              //   "underAge":'',
              //   "skipemailverification":false,
              //   "skipMobileVerification":true,

              //   });
              //   var myHeaders = new Headers();
              //   console.log("raw==>",raw);
              //   //return false;
              //   console.log("requestOptions==>",raw);
              //   //return false;
              //   var requestOptions = {
              //   method: 'POST',
              //   headers: myHeaders,
              //   body: raw,
              //   redirect: 'follow'
              //   };
              //   //fetch(otpvarify, requestOptions)
              //   fetch(smarttech, requestOptions)
              //   .then(response => response.json())
              //   .then(async result =>{
              //   console.log(result);

              //   console.log("5555");
              // let password = formData.hashedPassword;
              // var needparent=true;
              // //var parentstatus=0;
              // if(formData.userAge>=formData.underAge)
              // {
              //    needparent=false;
              //   // parentstatus=1;
              // }
              // console.log('in ==>');

              // const userMasterDetailsData = { 'id':formData.userid,'isParent':needparent};
              // let userMasterupdate=await API.graphql(graphqlOperation(updateUserMaster, { input: userMasterDetailsData }));

              // console.log('update user master');
              // const userDetailsData = {
              //   'id':formData.userdetailsid,
              //   'first_name':formData.userDetailsData.first_name,
              //   'last_name': formData.userDetailsData.last_name,
              //   'username': username,
              //   'dob':formData.userDetailsData.dob,
              //   'gender': formData.userDetailsData.gender,
              //   'mobile_no':formData.userDetailsData.mobile_no,
              //   'referralCode':formData.userDetailsData.referralCode,
              //   'isMobileVerified':false,
              //   'isParentVerified':false,
              //   'isSelfEmailVerified':true,
              //   'isparentRequestSent':false,
              //   'mobileCountrycode':formData.countryCode };

              //   let userUpdate=await API.graphql(graphqlOperation(updateUserProfileDetails, { input: userDetailsData }));
              //   console.log("UPDATE PROFILE DETAILS")
              //     sendRequestAfterRegd(formData.email.toLowerCase(),formData.userdetailsid,formData);
              //     console.log("DONE REGD REQUEST")
              //      const welcomeemail= sendWelcomeEmail(formData.userid);
              //      console.log("SEND WELCOME EMAIL")
              //      if(welcomeemail)
              //      {
              //       console.log("BEFORE EVENT LOG")
              //      addEventLog(formData.userdetailsid,formData.userdetailsid,'e3aeabb7-e0ba-473e-a2d3-0f5458df6ab3',userDetailsData,'')
              //      console.log("AFTER EVENT LOG")

              //      }

              //  localStorage.setItem('email', formData.email);
              //  localStorage.setItem("userID", formData.userid);
              //  dispatch(userActions.login(formData.email.toLowerCase(),formData.password));
              //  dispatch(success(userDetailsData,false));
              //  console.log("SUCCESS")
              //    dispatch(loaderActions.stop());
              //   })
              //   .catch(error => {console.log('error', error);});
              dispatch(loaderActions.stop());
            });
          })
          .catch((err) => {
            dispatch(alertActions.error("Oops. Something went wrong!"));
            dispatch(loaderActions.stop());
          });
      } else {
        dispatch(
          alertActions.error("This email address is already registered")
        );
        dispatch(failure("This email address is already registered"));
      }
    });
    dispatch(loaderActions.stop());
  };

  function request(user) {
    return { type: REGISTER_REQUEST, user };
  }
  function success(user, logid) {
    return { type: FINAL_REGISTER_COMPLETION, user, logid: logid };
  }
  function failure(error) {
    return { type: REGISTER_FAILURE, error };
  }
  async function userExist(email) {
    console.log("email", email);
    const userMasterData = await fetchItemsNextToken({
      query: queries.listUserMasters,
      variables: { filter: { email: { eq: email } }, limit: 10000 },
    });
    const items = userMasterData;
    let newMasterData = items.filter((item) => item._deleted !== true);
    if (newMasterData.length > 0) {
      if (newMasterData[0].password == "") {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
    //   Auth.configure({
    //     authenticationFlowType: 'USER_PASSWORD_AUTH',
    //   })
    //   return Auth.signIn(email.toLowerCase(), '123').then(res => {
    //       return false;
    //   }).catch(error => {
    //    const code = error.code;
    //    console.log(code);
    //    switch (code) {
    //        case 'UserNotFoundException':
    //            return true;
    //        case 'NotAuthorizedException':
    //            return false;
    //        case 'PasswordResetRequiredException':
    //          return false;
    //        case 'UserNotConfirmedException':
    //            return false;
    //        default:
    //            return false;
    //    }
    //  });
  }
  async function checkUsername(username1) {
    let username = username1.replace(/ +/g, "");
    //const userData = await API.graphql(graphqlOperation(queries.listUserProfileDetails,{filter: {username: {eq: username}},limit:10000}));
    const userData = await fetchItemsNextToken({
      query: queries.listUserProfileDetails,
      variables: { filter: { username: { eq: username } }, limit: 500 },
    });
    const items = userData;
    let newData = items.filter((item) => item._deleted !== true);
    if (newData.length > 0) {
      return checkUsername(username + newData.length);
    } else {
      return username;
    }
  }
}
